import React from 'react';
import IconFavouriteSelected from '../svg/IconFavouriteSelected';
import { gridBorder } from './styles';
import IconChevronDown from '../svg/IconChevronDown';
import IconChevronUp from '../svg/IconChevronUp';
import Tooltip from '../Tooltip';
import { border } from '../styles';

const FavouriteHeaderCell = ({
    def,
    onSortOrderChange,
    scrollPxH = 0,
    scrollPxV = 0,
    actionIconSize
}) => {
    const sortIcon = {
        height: 12,
        width: 16,
        fill: '#414141',
        verticalAlign: 'middle'
    };

    const cell = {
        ...gridBorder,
        borderTop: border,
        backgroundColor: '#FFFFFF',
        cursor: def.sortable ? (onSortOrderChange ? 'pointer' : 'auto') : 'auto',
        zIndex: 200,
        right: def.isSticky ? 0 : scrollPxH,
        bottom: scrollPxV
    };

    return (
        <th
            {...def.props}
            width={def.width}
            style={{ ...cell, ...def.style }}
            onClick={
                def.sortable && typeof onSortOrderChange === 'function'
                    ? () => onSortOrderChange(def)
                    : null
            }
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <div>
                    <Tooltip text='Favourite' marginTopAdjustment={-6}>
                        <IconFavouriteSelected
                            size={actionIconSize + 5}
                            style={{ fill: '#FAA800', stroke: '#FD9A00' }}
                        />
                    </Tooltip>
                </div>
                {def.sortable && typeof onSortOrderChange === 'function' && (
                    <div>
                        {def.sortOrder === '' || def.sortOrder === 'asc' ? (
                            <IconChevronDown
                                viewBox='15 14 22 22'
                                style={sortIcon}
                            />
                        ) : (
                            <IconChevronUp
                                viewBox='15 14 22 22'
                                style={sortIcon}
                            />
                        )}
                    </div>
                )}
            </div>
        </th>
    );
};

export default FavouriteHeaderCell;
